import React, { FunctionComponent } from 'react'
import { Row, BodyText, LoadingSpinner } from '@paypalcorp/pp-react'
import Linkify from 'react-linkify'
import { YoutubeVideo } from '../../../components/layout/'
import { ProductCard } from './ProductCard'

export const VideoSection: FunctionComponent<{ video: any }> = ({ video }) => {
  const noVideoId = typeof video?.id === 'undefined'

  return (
    <div style={{ paddingBottom: '3rem' }} data-testid="video-section">
      {noVideoId ? (
        <LoadingSpinner screenReaderText="loading" />
      ) : (
        <>
          <Row>
            <YoutubeVideo
              embedUrl={`https://www.youtube-nocookie.com/embed/${video?.id}`}
              title="PayPal Videos"
            />
          </Row>
          <Row
            style={{
              display: 'flex',
              padding: '2rem 0',
            }}
          >
            {video?.documentation ? (
              <ProductCard
                title="View integration doc"
                url={video?.documentation}
                thumbnail
              />
            ) : null}
            {video?.SourceCode ? (
              <ProductCard
                title="View source code on Github"
                url={video?.SourceCode}
                thumbnail
              />
            ) : null}
          </Row>
          <Row>
            <BodyText style={{ whiteSpace: 'break-spaces', width: '100%' }}>
              <Linkify
                componentDecorator={(decoratedHref, decoratedText, key) => {
                  return (
                    <span key={key}>
                      <a
                        href={decoratedHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          maxWidth: '100%',
                          display: 'inline-block',
                          wordWrap: 'break-word',
                        }}
                      >
                        {decoratedText.trim()}
                      </a>
                    </span>
                  )
                }}
              >
                {video?.description}
              </Linkify>
            </BodyText>
          </Row>
        </>
      )}
    </div>
  )
}
